export const state = {
  pageSize: undefined, // default
};

export const mutations = {
  setPageSize(state, payload) {
    state.pageSize = payload;
  },
};
